import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../components/table";
import { fetchPopularCourts } from "../../api/endpoint";
import axios from "axios";
import { useSelector } from "react-redux";
import Pagination from "../../components/pagination";

const headings = [
  { name: "Rank", fieldName: "rank", isSortable: false, sortKey: "none" },
  { name: "Name", fieldName: "name", isSortable: false, sortKey: "none" },
  {
    name: "Number of Games",
    fieldName: "numberOfGames",
    isSortable: false,
    sortKey: "none",
  },
];

const PopularCourts = () => {
  const { auth } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);
  const [courts, setCourts] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const pageSize = 5; // or any number of items per page

  useEffect(() => {
    getPopularCourts();
  }, []);

  const getPopularCourts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchPopularCourts, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      const data = response?.data?.map((court, index) => ({
        rank: index + 1,
        name: court?.courtName,
        numberOfGames: court?.numberOfGames,
      }));
      setCourts(data);
    } catch (error) {
      console.error("Error fetching popular courts", error);
    } finally {
      setLoading(false);
    }
  };

  const paginatedData = courts.slice(
    currentPage * pageSize,
    currentPage * pageSize + pageSize
  );

  return (
    <div>
      <div className="card rounded-4">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h5 className="mb-3">Popular Courts</h5>
            <Link to="/courts" style={{ textDecoration: "none" }}>
              See All
            </Link>
          </div>
          <Table
            headings={headings}
            data={paginatedData}
            enablePagination={false}
            className="table-striped"
            card={false}
          />
        </div>
        {/* {loading && <Loader />} */}
      </div>
      {courts.length > pageSize && (
        <div className="d-flex justify-content-end mt-2">
          <Pagination
            totalPages={Math.ceil(courts.length / pageSize)}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}
    </div>
  );
};

export default PopularCourts;
